import { Templates } from "./Templates";

/**Utility functions */
export class Utility
{
	/**
	 * Simplified JS de-duplication for cross-browser compatibility i.e. IE
	 * @param commodities array to remove duplicates from
	 */
	static DeDupCommodities (commodities)
	{
		let commodityArray : string[] = [];
		commodities.forEach((element) =>
		{
			if (commodityArray.indexOf(element["commodity"]) === -1)
			{
				commodityArray.push(element["commodity"]);
			}
		});
		return commodityArray;
	}

	/**
	 * Resetting data grid settings
	 * @param gridId Grid ID to reset
	 */
	static ResetDataGrid(gridId)
	{
		var grid = $(gridId).dxDataGrid('instance');
		grid.option('dataSource', []);
		grid.pageIndex(0);
	}

	/** Reload the main page datagrid */
	static ReloadPricesGrid()
	{
		// Always be sure to set to first page
		$('#' + Templates.Ids.gridContainer).dxDataGrid('instance').pageIndex(0);

		// Reload data on grid and mobile list
		$('#' + Templates.Ids.gridContainer).dxDataGrid('getDataSource').reload();
		$('#' + Templates.Ids.simpleList).dxList('getDataSource').reload();
	}

	/**
	 * Toggles the mobile chart on and off when screen size changes, since mobile by default does not display the chart
	 * @param option option value
	 */
	static MobileChartToggle(option)
	{
		var chartRow = $('#' + Templates.Ids.popupChartRow);
		if (option.value)
		{
			chartRow.removeClass("hidden-xs");
			var chart = $('#' + Templates.Ids.popupRevenuePricesChart).dxChart('instance');
			chart.render();
		}
		else
		{
			chartRow.addClass("hidden-xs");
		}
	}
}